import { createSelector } from 'reselect';

import { Store } from '../reducers/reducers';

const getFeedback = (store: Store) => store.feedback;

const feedbackSelector = createSelector(getFeedback, (feedback) => feedback.message);

export default feedbackSelector;
